"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbLandingTypes = exports.protoEnumTypes = exports.landingDisplayLabels = void 0;
const landingDisplayLabels = {
    local: 'User Profile Preference',
    observationDeck: 'Observation Deck',
    nmsDashboard: 'NMS Dashboard',
    networkExplorer: 'Network Explorer',
    library: 'Library',
    synthetics: 'Synthetics',
    explorer: 'Data Explorer',
    alerting: 'Alerting',
    insights: 'Insights',
    dashboard: 'Dashboard',
    'saved-view': 'Saved View',
    'quick-view': 'Quick View',
    'market-intel': 'Market Intelligence'
};
exports.landingDisplayLabels = landingDisplayLabels;
const protoEnumTypes = {
    LANDING_TYPE_LOCAL: 'local',
    LANDING_TYPE_OBSERVATION_DECK: 'observationDeck',
    LANDING_TYPE_NMS_DASHBOARD: 'nmsDashboard',
    LANDING_TYPE_NETWORK_EXPLORER: 'networkExplorer',
    LANDING_TYPE_LIBRARY: 'library',
    LANDING_TYPE_SYNTHETICS: 'synthetics',
    LANDING_TYPE_EXPLORER: 'explorer',
    LANDING_TYPE_ALERTING: 'alerting',
    LANDING_TYPE_INSIGHTS: 'insights',
    LANDING_TYPE_DASHBOARD: 'dashboard',
    LANDING_TYPE_SAVED_VIEW: 'saved-view',
    LANDING_TYPE_QUICK_VIEW: 'quick-view',
    LANDING_TYPE_MARKET_INTELLIGENCE: 'market-intel'
};
exports.protoEnumTypes = protoEnumTypes;
const dbLandingTypes = Object.fromEntries(Object.entries(protoEnumTypes).map(([enumName, key]) => [key, enumName]));
exports.dbLandingTypes = dbLandingTypes;
